import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { createShortLink } from './utils/shortLinkStore'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const isValidUrl = (value) => {
  try {
    const url = new URL(value)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}

const UrlShortener = () => {
  useDocumentMeta({
    title: 'Encurtador de URL | jarder.dev',
    description:
      'Transforme um link longo em um link curto jarder.dev/s/xxxxxx. ' +
      'Grátis, sem cadastro.',
  })

  const [input, setInput] = useState('')
  const [shortUrl, setShortUrl] = useState('')
  const [shortId, setShortId] = useState('')
  const [error, setError] = useState('')
  const [status, setStatus] = useState('idle')

  const shorten = async () => {
    if (!isValidUrl(input)) {
      setError('Digite uma URL válida, começando com http:// ou https://.')
      setShortUrl('')
      return
    }
    setError('')
    setStatus('loading')
    try {
      const id = await createShortLink(input)
      setShortUrl(`${window.location.origin}/s/${id}`)
      setShortId(id)
      setStatus('idle')
      trackEvent('tool_generate', { tool: 'url_shortener' })
    } catch {
      setError('Não foi possível encurtar agora. Tente novamente.')
      setStatus('idle')
    }
  }

  const copy = () => {
    navigator.clipboard.writeText(shortUrl)
    trackEvent('tool_copy', { tool: 'url_shortener' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Encurtador de URL</h1>
      <p className="tool-disclaimer">
        O link curto redireciona pra URL original. Contamos quantos
        cliques o link recebe por dia (pra você acompanhar nas
        estatísticas), mas não coletamos nenhum dado de quem clica.
      </p>

      <div className="tool-field">
        <label htmlFor="long-url">URL longa</label>
        <input
          id="long-url"
          type="text"
          placeholder="https://exemplo.com/um-link-bem-longo"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>

      <button
        type="button"
        className="tool-button"
        onClick={shorten}
        disabled={status === 'loading'}
      >
        {status === 'loading' ? 'Gerando...' : 'Encurtar'}
      </button>

      {error && <p className="tool-error">{error}</p>}

      {shortUrl && (
        <div className="tool-result-card" style={{ marginTop: 20 }}>
          <span className="tool-result-label">Link curto</span>
          <span className="tool-result-value" style={{ wordBreak: 'break-all' }}>
            {shortUrl}
          </span>
          <div className="tool-result-actions">
            <button type="button" className="tool-button tool-button-secondary" onClick={copy}>
              Copiar
            </button>
            <Link
              to={`/ferramentas/encurtador-url/${shortId}`}
              className="tool-button tool-button-secondary"
            >
              Ver estatísticas
            </Link>
          </div>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Para que serve encurtar um link</h2>
        <p>
          Links curtos são mais fáceis de compartilhar em posts,
          legendas, cartões impressos ou mensagens com limite de
          caracteres, e ficam mais discretos que uma URL longa cheia de
          parâmetros. A página de estatísticas mostra quantos cliques o
          link recebeu por dia, útil para acompanhar o alcance de uma
          campanha ou divulgação sem precisar de uma ferramenta de
          analytics separada.
        </p>
      </div>
    </div>
  )
}

export default UrlShortener
